import { Component, Input, OnInit, ViewChild, Host, Optional, Injector } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { EasyFormComponent } from '../form/form.component';
import { FMSUtilityService } from '../../services/utility/utility.service';
import { FormGroupComponent } from '../form-group/form-group.component';
import { FormErrorComponent } from '../error/error.component';
import { BaseInputComponent } from '../base-input/base-input.component';
import { LocalizePipe } from '../../../../pipes/Localize.pipe';

@Component({
    selector: 'numberInput',
    templateUrl: 'number-input.component.html',
    styleUrls: [
        '../base-input/base-input.component.css'
    ]
})
export class NumberInputComponent extends BaseInputComponent implements OnInit {

    childOnInit() {

    }

    @Input() min : number;
    @Input() max : number;

    get familyId() { return 'input'; }

    constructor( @Host() parentForm: EasyFormComponent, @Optional() @Host() parentFormGroup: FormGroupComponent, protected injector: Injector) {
        super(parentForm, parentFormGroup, injector);
    }

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/number-input/number-input.component.ts